<ng-container *ngIf="member">
  <app-panel-header-image-view pretitle="{{(member[0].CShort || member[0].Continent) | transloco}}" [title]="member[0].MaName" [downtitle]="member[0].MaStatus" [banner_image]="provideBanner(member[0])" [logo]="member[0].NOC ? true : false">
  <app-third-nav-tab-component [elements]="routes"></app-third-nav-tab-component>
  <img *ngIf="routes.length > 0 && member[0].NOC" class="pretitle" [lazyLoad]="'//extranet.worldarchery.sport/Flags/' + member[0].NOC +'.svg'" />
  <div *ngIf="routes.length > 0  && member[0].NOC" class="banner__content__second__logo">
    <img [lazyLoad]="'//extranet.worldarchery.sport/MALogos/?NOC=' + member[0].NOC"/>
  </div>
  </app-panel-header-image-view>
</ng-container>
<app-app-content-page-wrapper>
  <router-outlet></router-outlet>
  <app-news-panel appRouterHide [pathsToBeHide]="['news']" [title]="'related_news' | transloco" [news]="news"></app-news-panel>
</app-app-content-page-wrapper>
